var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"text-center"},[_vm._v("\n      © "+_vm._s(new Date().getFullYear())+" "),_c('span',{staticStyle:{"color":"#FF8F00"}},[_vm._v("Beyond Pulse "+_vm._s(_vm.$t('OUTER_PAGES.footer')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }